import moment from "moment";

export default function formatDate(date, format = "DD/MM/YYYY hh:mm:ss A ZZ") {
  if (!date) return "-";

  if (moment.isMoment(date)) {
    return date.format(format);
  }

  if (typeof date === "number" || date instanceof Date) {
    const parsedDate = moment(date);
    return parsedDate.isValid() ? parsedDate.format(format) : "-";
  }

  if (typeof date === "string") {
    const parsedDate = moment(
      date,
      [
        moment.ISO_8601,
        "DD/MM/YYYY hh:mm:ss A ZZ",
        "DD/MM/YYYY hh:mm:ss A",
        "DD/MM/YYYY",
      ],
      true
    );

    if (parsedDate.isValid()) {
      return parsedDate.format(format);
    }

    return date;
  }

  const parsedDate = moment(date);
  return parsedDate.isValid() ? parsedDate.format(format) : "-";
}
